import { useState, useEffect } from "preact/hooks";

export function useCanCapture() {
  const [canCapture, setCanCapture] = useState(false);
  useEffect(() => {
    const hasMediaDevices = !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);
    const isMobile = /android|iphone|ipad|ipod|mobile/i.test(navigator.userAgent || "");
    setCanCapture(hasMediaDevices && isMobile);
  }, []);
  return canCapture;
}
